import { Outlet, NavLink } from 'react-router-dom';
import { Building2, Briefcase, Sparkles, LayoutDashboard } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SalesSidebar } from './SalesSidebar';

const MOBILE_NAV = [
  { to: '/research', label: 'Research', icon: Building2, ready: true },
  { to: '/corporate', label: 'Corporate', icon: Briefcase, ready: false },
  { to: '/subscription', label: 'OneLife', icon: Sparkles, ready: false },
  { to: '/dashboard', label: 'Board', icon: LayoutDashboard, ready: false },
];

export function SalesShell() {
  return (
    <div className="flex h-full w-full">
      <SalesSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <main className="min-w-0 flex-1 overflow-y-auto bg-background pb-20 md:pb-0">
          <Outlet />
        </main>
        {/* mobile bottom nav */}
        <nav className="fixed inset-x-0 bottom-0 z-20 flex border-t border-border/60 bg-card/95 backdrop-blur md:hidden">
          {MOBILE_NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'flex flex-1 flex-col items-center gap-0.5 py-2 text-2xs text-muted-foreground',
                  isActive && 'text-foreground',
                  !item.ready && 'pointer-events-none opacity-40',
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
